/**
 * Light mode theme
 *
 * @experimental - this is still in active development, assume that the API will change in a minor/patch version
 */
export var lightTheme = {
  grid: {
    stroke: '#d6d3d1',
    fill: 'none'
  }
};